export class BaseModule {
    /**
     * Initialize the component.
     *
     * This method creates a new class instance and calls its constructor.
     */
    static init() {
        new this();
    }
}
